import { render, staticRenderFns } from "./ReportComprehensiveTaxSystemAgents.vue?vue&type=template&id=b7770eb4"
import script from "./ReportComprehensiveTaxSystemAgents.vue?vue&type=script&lang=js"
export * from "./ReportComprehensiveTaxSystemAgents.vue?vue&type=script&lang=js"
import style0 from "./ReportComprehensiveTaxSystemAgents.vue?vue&type=style&index=0&id=b7770eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports